import { render, staticRenderFns } from "./Mealie.vue?vue&type=template&id=7e87e2dc&scoped=true&"
import script from "./Mealie.vue?vue&type=script&lang=js&"
export * from "./Mealie.vue?vue&type=script&lang=js&"
import style0 from "./Mealie.vue?vue&type=style&index=0&id=7e87e2dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e87e2dc",
  null
  
)

export default component.exports